// extracted by mini-css-extract-plugin
module.exports = {"inline":"_22FhE0hC9yEA9rsoUj_HyJ"};